import { Controller } from "@hotwired/stimulus"
import "tom-select/dist/css/tom-select.css";
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    // Initialize TomSelect
    new TomSelect(this.element, {
      plugins: ['remove_button', 'caret_position', 'input_autogrow']
    });

    // Use setTimeout to ensure the DOM has been updated with TomSelect elements
    setTimeout(() => {
      const wrapper = this.element.closest(".ts-wrapper");
      // Only apply dark mode if the wrapper exists
      if (wrapper && document.documentElement.classList.contains('dark')) {
        wrapper.classList.add("dark");
      }
    }, 50);

    // Move event listener to be independent of the wrapper check
    document.addEventListener("DOMContentLoaded", function () {
      const dropdowns = document.querySelectorAll(".ts-dropdown");
    
      dropdowns.forEach((dropdown) => {
        const rect = dropdown.getBoundingClientRect();
        if (rect.bottom > window.innerHeight) {
          dropdown.setAttribute("data-overflows", "true");
        }
      });
    });
  }
}
